const ENIndicatorFields = {
	"Adicionar campo de indicador": "Add indicator's field",
	"Novo campo":"New field",
	"Adicionar origem":"New source",
	"Alterar campo de indicador": "Change indicator's field",
	"Deseja realmente excluir campo": "Do you really want to delete the field",
	"Erro ao adicionar campo": "Error on adding field",
	"Erro ao alterar campo": "Error on changing field",
	"Erro ao excluir campo": "Error on deleting field",
	"Exclusão do campo de indicador": "Delete Indicator's field",
	"Excluir origem":"Delete source",
	"Erro ao selecionar campo":"Error on select field",
	"Campo de indicador adicionado com sucesso": "Indicator's field successfully added",
	"Campo de indicador alterado com sucesso": "Indicator's field successfully changed",
	"Campo de indicador excluído com sucesso": "Indicator's field successfully deleted",
	"A descrição do campo é requerido":"field's description is required",
	"O rótulo do campo é requerido":"field's label is required",
	"O número de casas decimais é requerido":"field's field decimal places number is required",
	"Número de casas decimais está incorreto":"Decimal places number is wrong",
	"Codigo do período é requerido":"field's code is required",
	"Qual a origem dos dados":"What is the data source",
	"Qual o formato dos dados":"Which data format",
	"Caminho de origem":"Source's path",
	"Data inicial da validade é requerida":"Expiration's initial date is required",
	"Data final da validade é requerida":"Expiration's end date is required",
	"A fórmula é requerida":"Formula is required",
	"A fórmula está inválida":"Formula is invalid",
	"Tipo é requerido":"Type is required",
	"Origem de dados é obrigatória":"Data source is required",
	"Formato dos dados é obrigatório":"Data format is required",
	"Origem de dados para integração":"Data source for integration",
	"Fórmula ou integração":"Formula or integration",
	"Calculado com base em uma fórmula":"Based in a formula result",
	"Integração com Banco de Dados":"Data base integration",
	"Integração com Web Service":"Web service integration",
	"Crie uma fórmula utilizando nosso assistente (apenas clique no botão x²) ou informe um condicional SQL":
	"Create a formula using our wizard (click on button x²) or inform a SQL statement",
	"Se você for informar o valor, deixe o campo vazio":"If you gonna inform a value,then let the field empty",
	"O quê devo informar para Fórmula":"What i should inform for a formula",
	"O quê devo informar para Integração":"What i should inform for a Integration",
	"Informe uma consulta SQL caso queira buscar o valor de outros sistemas":
	"Inform a SQL Statement if you want to search values from other systems",
	"Você pode utilizar os binds":"You can use the binds",
	"O quê devo informar para Descrição":"What i should inform for a Description",
	"Informe uma descrição para sua fórmula/integração":"Inform a description for your formula/intergation",
	"Isso ajudará futura manutenção":"It helps for a future maintenance",
	"Explique a lógica e o resultado esperado":"Explain the logic and the expected result",
	"Mostrar detalhes":"Show details",
	"Onde é usado":"Where is used",
	"Copiar campo de indicador":"Copy indicator's field"
};

export default ENIndicatorFields;
